import { array, mixed, object, string } from 'yup';

const LanguagesSchema = object().shape({
    sourceLanguage: object().shape({
        label: string(),
        value: string().required('Base language is required'),
    }),
    targetLanguages: array()
        .of(
            object({
                label: string(),
                value: string().required(),
            }),
        )
        .min(1, 'At least one target language is required'),
});

const ProjectNameSchema = object().shape({
    name: string().max(255, 'Project names maximum length is 255').required('Project name is required'),
});

const CreateProjectSchema = ProjectNameSchema.concat(LanguagesSchema).concat(
    object().shape({
        segmentationRulesType: string().when('isSegmentationEnabled', {
            is: true,
            then: string().required(),
        }),
        segmentationRulesFile: mixed().when('segmentationRulesType', {
            is: 'custom',
            then: mixed()
                .required('A SRX file is required for setting up custom rules.')
                .test(
                    'segmentationRulesFile',
                    'We only accept SRX file types for setting up custom rules.',
                    (value) => value && value.name && value.name.split('.').pop() === 'srx',
                ),
        }),
        contentIntegration: mixed().when('projectType', {
            is: '2',
            then: mixed()
                .required('Content integration is required')
                .test('contentIntegration', 'Content integration is required', (value) => value && value.value),
        }),
    }),
);

export { CreateProjectSchema, ProjectNameSchema, LanguagesSchema };
